// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/drawer/style/index.less
// module id = 1113
// module chunks = 1